if (typeof window.loadRecommendations === 'undefined') {
  window.loadRecommendations = function () {
    let container = document.getElementById('cart-rec-container')
    let section = document.getElementById('cart-rec-section')
    let wrapper = document.getElementById('cart-rec-section-wrapper')

    if (wrapper && wrapper.style.display === 'none') {
      wrapper.style.display = 'block'
      container = wrapper.querySelector('#cart-rec-container')
      section = wrapper.querySelector('#cart-rec-section')
    }

    if (!container) {
      if (!wrapper) {
        const drawerContent = document.querySelector('.cart-drawer-content')
        if (drawerContent) {
          wrapper = document.createElement('div')
          wrapper.id = 'cart-rec-section-wrapper'
          drawerContent.appendChild(wrapper)
        }
      }

      if (wrapper) {
        section = document.createElement('div')
        section.id = 'cart-rec-section'
        section.className = 'cart-recommendations border-t border-gray-200 pt-4 mt-4'
        section.style.display = 'none'

        container = document.createElement('div')
        container.id = 'cart-rec-container'

        section.appendChild(container)
        wrapper.appendChild(section)
      }
    }

    if (!container || !section) {
      return
    }

    container.innerHTML = `
      <div class='flex justify-center py-6'>
        <div class='animate-spin rounded-full h-6 w-6 border-2 border-primary border-t-transparent'></div>
      </div>
    `
    section.style.display = 'block'

    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        if (!cart.items || cart.items.length === 0) {
          section.style.display = 'none'
          return
        }

        const firstProductId = cart.items[0].product_id
        const cartProductIds = cart.items.map((item) => item.product_id)

        return fetch(`/recommendations/products.json?product_id=${firstProductId}&limit=6`)
          .then((res) => res.json())
          .then((data) => {
            if (!data.products || data.products.length === 0) {
              section.style.display = 'none'
              return
            }

            const filtered = data.products.filter((p) => !cartProductIds.includes(p.id))

            if (filtered.length === 0) {
              section.style.display = 'none'
              return
            }

            section.style.display = 'block'

            container.innerHTML = `
              <h3 class='text-sm font-bold text-black mb-3 px-1'>También te puede interesar</h3>
                <div class="flex gap-3 overflow-x-auto pb-2 snap-x snap-mandatory" style="scrollbar-width: thin;">
                  ${filtered
                    .map((product) => {
                      const variant = product.variants[0]
                      const price = new Intl.NumberFormat('es-MX', {
                        style: 'currency',
                        currency: 'MXN',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(variant.price / 100)

                      return `
                        <div class="min-w-[140px] max-w-[140px] shrink-0 snap-start bg-white border border-gray-200 rounded-2xl p-3 flex flex-col gap-2 transition-shadow duration-200">
                          <a href="${product.url}" class="block">
                            <div class="w-full h-32 bg-gray-50 rounded-xl overflow-hidden flex items-center justify-center">
                              <img 
                                src="${product.featured_image || ''}" 
                                alt="${product.title}" 
                                class="w-full h-full object-contain transition-transform duration-300"
                                loading="lazy"
                              >
                            </div>
                          </a>
                          <div class="flex flex-col gap-2 flex-1">
                            <a href="${product.url}" class="text-xs font-semibold text-black line-clamp-2 leading-tight hover:text-primary transition-colors">
                              ${product.title}
                            </a>
                            <div class="mt-auto">
                              <p class="text-sm font-bold text-primary mb-2">${price}</p>
                              <button class="w-full py-2 bg-primary text-white text-xs font-semibold rounded-full transition-all duration-150 cursor-pointer hover:bg-primary/95">
                                Agregar
                              </button>
                            </div>
                          </div>
                        </div>
                      `
                    })
                    .join('')}
                </div>
              `
          })
      })
      .catch(() => {
        section.style.display = 'none'
      })
  }
}

document.addEventListener('cart:updated', (e) => {
  if (typeof window.loadRecommendations === 'function' && e.detail && e.detail.productsChanged) {
    setTimeout(() => window.loadRecommendations(), 300)
  }
})

document.addEventListener('cart:item-added', () => {
  if (typeof window.loadRecommendations === 'function') {
    setTimeout(() => window.loadRecommendations(), 300)
  }
})
